import { useQueryClient } from "@tanstack/react-query";

import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Timeout } from "react-number-format/types/types";
import QRCode from "react-qr-code";

import Spinner from "@/components/helpers/Spinner/Spinner";
import VerificationInput from "@/components/inputs/VerificationInput";

import { useCheckCode } from "@/hooks/api/useCheckCode";
import { USER_KEYS, useGetLoginCode } from "@/hooks/api/user.hooks";

import AuthTitle from "../AuthTitle.";

const AuthWithCodeModal = () => {
  const { t } = useTranslation();

  const resetTimer = useRef<Timeout>();
  const checkCodeTimer = useRef<Timeout>();

  const { data: res, isPending } = useGetLoginCode();

  const queryClient = useQueryClient();

  const code = res.data.code;

  useCheckCode(res.data.code);

  useEffect(() => {
    if (code) {
      clearTimeout(resetTimer.current);
      resetTimer.current = setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: USER_KEYS.loginCode });
      }, 1000 * 60);
      checkCodeTimer.current = setInterval(() => {}, 3000);
    }

    return () => {
      clearTimeout(resetTimer.current);
    };
  }, [code]);

  if (isPending) {
    return <Spinner />;
  }

  return (
    <div>
      <AuthTitle goback title={t("Auth.enter-via-code")} subtitle={""} className="mb-10" />
      <VerificationInput value={code.toString()} error={false} />
      <div className={"mt-10 flex w-full flex-col items-center max-lg:hidden"}>
        <h3 className={"mb-4 text-center text-base"}>{t("Sessions.scan-qr")}</h3>
        {code && (
          <QRCode
            style={{ height: "auto", maxWidth: "18.75rem", width: "18.75rem" }}
            value={code.toString()}
            viewBox={`0 0 256 256`}
            bgColor="black"
            fgColor="white"
          />
        )}
      </div>
    </div>
  );
};

export default AuthWithCodeModal;
